module.exports = __webpack_public_path__ + "static/media/boost-post-for-fb.437f0388.jpg";